import React from 'react';
import { change, Field } from 'redux-form';
import omit from 'lodash/omit';
import { CheckBox } from 'chameleon/ui-stack/ui/forms/check-box-list';

/**
 * Attestation agreement wrapper for injecting redux-form data
 * in the attestation agreement field.
 * */
const AttestationAgreementWrapper = (WrappedComponent) => (props) => (
  <Field
    name={props.name}
    component={WrappedComponent}
    props={omit(props, ['name'])}
  />
);

/**
 * Attestation agreement redux form field.
 * */
const AttestationAgreementField = (props) => {
  const {
    value,
    input: { name },
    meta: { form, dispatch },
    handleAttestationLink,
  } = props;

  const toggle = () => {
    dispatch(change(form, name, !value));
  };

  return (
    <CheckBox
      className="attestation-container"
      onClick={toggle}
      name={name}
      isChecked={value}
    >
      I have read and agree to the &nbsp;
      <a role="link" tabIndex="0" onClick={handleAttestationLink}>
        Practice Exam Attestation
      </a>
    </CheckBox>
  );
};

export default AttestationAgreementWrapper(AttestationAgreementField);
